import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { Subscription as RxJsSubscription } from 'rxjs';
import { ErrorService } from '@app/services';
import { ModuleEnSavoirPlus } from '../../module-en-savoir-plus';
import { ModuleEnSavoirPlusService } from '../../module-en-savoir-plus.service';
@Component({
	selector: 'hpf-module-en-savoir-plus-edit',
	templateUrl: './module-en-savoir-plus-edit.component.html',
})
export class ModuleEnSavoirPlusEditComponent implements OnInit, OnDestroy {
	/** The module en savoir plus */
	moduleEnSavoirPlus = new ModuleEnSavoirPlus();
	/** The module en savoir plus */
	private id: string;
	/** The id subscription */
	private idSubscription: RxJsSubscription;
	/** Constructor */
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private errorService: ErrorService,
		private moduleEnSavoirPlusService: ModuleEnSavoirPlusService
	) {}
	/** Init */
	ngOnInit() {
		// Get the module en savoir plus after reading the id
		this.idSubscription = this.route.params.subscribe((params) => {
			this.id = params['id'];
			this.refresh();
		});
	}
	/** Destroy */
	ngOnDestroy() {
		this.idSubscription.unsubscribe();
	}
	/** Fetch module en savoir plus from API */
	private refresh() {
		this.moduleEnSavoirPlusService
			.get(this.id, {
				_populate: [
					'description',
					'diaporama',
					'image',
					'subtitle',
					'title.lang',
				],
			})
			.then((moduleEnSavoirPlus: ModuleEnSavoirPlus) => {
				this.moduleEnSavoirPlus.fromObject(
					moduleEnSavoirPlus.toObject()
				);
			})
			.catch((error) => this.errorService.handle(error));
	}
	/** Called when the module en savoir plus is updated */
	onUpdate(): void {
		this.refresh();
	}
	/** Called when the module en savoir plus is deleted */
	onDelete(): void {
		this.router
			.navigateByUrl('/module-en-savoir-plus')
			.catch((error) => this.errorService.handle(error));
	}
}
